// Import auth service for authenticated requests
import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

export const trialsService = {
  // Get all trials (paginated)
  async getAllTrials(params = {}) {
    if (!SERVER_URL) {
      console.error('SERVER_URL is not configured');
      throw new Error('API server URL is not configured');
    }
    try {
      const {
        page = 1,
        limit = 20,
        q,
      } = params;

      const searchParams = new URLSearchParams();
      if (page) searchParams.set('page', String(page));
      if (limit) searchParams.set('limit', String(limit));
      if (q) searchParams.set('q', q);

      const url = `${SERVER_URL}/trials${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

      const response = await fetch(url, {
        headers: authService.getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch trials: ${response.status}`);
      }
      const result = await response.json();
      // Return the full response including pagination metadata if provided by API
      return result;
    } catch (error) {
      console.error('Error fetching trials:', error);
      return {
        success: false,
        total: 0,
        count: 0,
        page: 1,
        limit: 20,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
        data: [],
      };
    }
  },

  // Get trial by trial ID
  async getTrialByTrialId(trialId) {
    try {
      const response = await fetch(`${SERVER_URL}/trials/by-trial-id/${trialId}`, {
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        return data.data || data;
      } else {
        throw new Error(`Failed to fetch trial by trial ID: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching trial by trial ID:', error);
      return null;
    }
  },

  // Create a new trial
  async createTrial({ kid_name, kid_images, story }) {
    try {
      const response = await fetch(`${SERVER_URL}/trials`, {
        method: 'POST',
        headers: {
          ...authService.getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ kid_name, kid_images, story }),
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch {}
        throw new Error(errorData.error || errorData.message || `Failed to create trial: ${response.status}`);
      }
    } catch (error) {
      console.error('Error creating trial:', error);
      throw error;
    }
  },

  // Regenerate a trial
  async regenerateTrial(trialId, reason = 'Manual regeneration requested') {
    try {
      const response = await fetch(`${SERVER_URL}/trials/${trialId}/regenerate`, {
        method: 'POST',
        headers: {
          ...authService.getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ reason }),
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch {}
        throw new Error(errorData.error || errorData.message || `Failed to regenerate trial: ${response.status}`);
      }
    } catch (error) {
      console.error('Error regenerating trial:', error);
      throw error;
    }
  },
};


